import * as React from "react";
import { forwardRef } from "react";
const SvgMenu = (props, ref) => /* @__PURE__ */ React.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M1.66663 4.16667V5.83333H18.3333V4.16667H1.66663ZM1.66663 9.16667V10.8333H18.3333V9.16667H1.66663ZM1.66663 14.1667V15.8333H18.3333V14.1667H1.66663Z", fill: "currentColor" }));
const ForwardRef = forwardRef(SvgMenu);
export default ForwardRef;
